module.exports = __webpack_public_path__ + "img/com.electrolux.airconditioner.26288dac.webp";